import React, { useEffect, useState, useRef } from "react";
import { BellOutlined, GlobalOutlined, ShoppingCartOutlined } from "@ant-design/icons";
import { Avatar, Badge } from "antd";
import { useNavigate } from "react-router-dom";
import { selectCartItems } from '../../Utilities/cartSelectors';
import NotificationModal from "../NotificationModal/NotificationModal";
import { useSelector } from 'react-redux';

function LoggedInUserInfo({ setLoggedIn, profileImage, setProfileImage }) {
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const [userName, setUserName] = useState("User");
  const [role, setRole] = useState("")
  const [userInitials, setUserInitials] = useState("U");
  const navigate = useNavigate();
  const menuRef = useRef(null);
  const cart = useSelector(selectCartItems) || [];

  const formatBase64Image = (base64) => {
  if (!base64) return null;
  return base64.startsWith("data:image")
    ? base64
    : `data:image/jpeg;base64,${base64}`;
};

 // Watch for changes in profileImage prop
  useEffect(() => {
    const userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");
    
    if (userInfo.role) {
      setRole(userInfo.role)
    }

    if (userInfo.name) {
      setUserName(userInfo.name);
      const names = userInfo.name.split(' ');
      let initials = names[0].substring(0, 1).toUpperCase();
      if (names.length > 1) {
        initials += names[names.length - 1].substring(0, 1).toUpperCase();
      }
      setUserInitials(initials);
    } else if (userInfo.email) {
      const emailName = userInfo.email.split('@')[0];
      setUserName(emailName);
      setUserInitials(emailName.substring(0, 1).toUpperCase());
    }
  }, [profileImage]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        
        const avatarButton = document.querySelector('.user-info-container');
        if (!avatarButton.contains(event.target)) {
          setUserMenuOpen(false);
        }
      }
    };

    if (userMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [userMenuOpen]);

  const toggleUserMenu = (e) => {
    e.stopPropagation();
    setUserMenuOpen(!userMenuOpen);
  };

  const handleViewProfileClick = () => navigate("/user-profile");
  const handleCreateClass = () => navigate("/teacher-home");
  const handleExams = () => navigate("exam-system");
  const handleDashboard = () => navigate("/admin-page/dashboard");

  const handleSignOut = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("userInfo");
    localStorage.removeItem("userPhoto");
    setProfileImage(null);
    setLoggedIn(false);
    navigate("/");
  };
 
  // Base user options for all users
  const baseUserOptions = [
    { label: 'My Classes', route: '/user-classes' },
    { label: 'Classes', route: '/courses' },
    { label: 'Account Settings', route: '/account-settings' },
    { label: 'Exams', route: '/exam-system' },
    { label: 'Refer A Friend', route: null },
    { label: 'Help', route: '/faq' },
    { label: 'Sign Out', route: null, onClick: handleSignOut },
  ];

  // Admin-specific options
  const adminOptions = [
    { label: 'Dashboard', route: '/admin-page/dashboard', onClick: handleDashboard }
  ];

  // Combine options based on user role
  const getUserOptions = () => {
    if (role === 'Admin') {
      // Insert Dashboard at the beginning for Admin users
      return [...adminOptions, ...baseUserOptions];
    }
    return baseUserOptions;
  };

  const userOptions = getUserOptions();

  return (
   <div className="user-container">
      <GlobalOutlined className="icon" />
      <Badge 
        count={cart.length} 
        overflowCount={9}
        style={{ 
          backgroundColor: 'red',
          color: '#fff',
          fontWeight: 'bold'
        }}
      >
        <ShoppingCartOutlined 
          className="icon" 
          onClick={() => navigate('/cart')} 
          style={{ fontSize: '20px' }}
        />
      </Badge>
  
      <NotificationModal />

      <div className="user-info-container" onClick={toggleUserMenu}>
        {profileImage ? (
          <Avatar 
            src={formatBase64Image(profileImage)} 
            size={32}
            onError={() => {
              setProfileImage(null);
            }}
          />
        ) : (
          <Avatar 
            size={32}
            style={{ backgroundColor: '#043f2d' }}
          >
            {userInitials}
          </Avatar>
        )}
      </div>

      {userMenuOpen && (
         <div className="user-dropdown-menu" ref={menuRef}>
          <div className="user-info">
            {profileImage ? (
              <Avatar 
               src={formatBase64Image(profileImage)} 
                size={64}
                className="user-avatar-large"
                onError={() => {
                  setProfileImage(null);
                }}
              />
            ) : (
              <Avatar 
                size={64}
                className="user-avatar-large"
                style={{ backgroundColor: '#043f2d' }}
              >
                {userInitials}
              </Avatar>
            )}
            <span className="user-name">{userName}</span>
            <span className="create-user" onClick={handleViewProfileClick}>
              View Profile
            </span>
          </div>

          <div className="user-options-title-learn">
            <span className="user-options-text">Learn</span>
          </div>

          {userOptions.map((option, index) => (
            <div
              key={index}
              className={`user-menu-item ${option.label === 'Dashboard' ? 'admin-menu-item' : ''}`}
              onClick={() => {
                if (option.route) {
                  navigate(option.route);
                } else if (option.onClick) {
                  option.onClick();
                } else {
                  console.log(`${option.label} clicked`);
                }
                setUserMenuOpen(false);
              }}
            >
              {option.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default LoggedInUserInfo;